// WP6-B.5 live shim. Static JSON retired.
//
// History:
//   • WP6-B (2026-10-17) — these helpers resolved against static JSON
//     snapshots under `../data/*.json`, auto-fetched from the live
//     Studio G4 pod's public API.
//   • WP6-B.5 (2026-10-18) — flipped to this pod's own live endpoints
//     under `/api/public/*`. The CMS admin UI at `/admin/marketing-
//     website` is now the source of truth. Static JSON files have been
//     removed and the `/g4-media/` static directory retired.
//
// Public functions keep their original signatures so the three
// consumer components (HomePage.jsx, ProjectDetail.jsx — via the
// FadeIn / SEO modules — and the Request-Quote form's background
// image resolver) require ZERO changes beyond the URL prefix flip in
// `getFileServeUrl`.

import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const PUBLIC = `${BACKEND}/api/public`;

const client = axios.create({
    baseURL: PUBLIC,
    // No credentials — these endpoints are strictly unauthenticated.
    withCredentials: false,
});

export async function getProjects() {
    const { data } = await client.get("/projects");
    return data;
}

export async function getProject(id) {
    const { data } = await client.get(`/projects/${id}`);
    return data;
}

export async function getAbout() {
    const { data } = await client.get("/about");
    return data;
}

export async function getSiteImages() {
    const { data } = await client.get("/site-images");
    // Pre-WP6-B.5 the hero/about keys arrived as bare UUIDs that
    // required `getFileServeUrl()` prefixing in the consumer. The
    // backend now returns fully-resolved URLs for every slot (including
    // external placeholders), so callers can treat the values as ready
    // to use.
    return data;
}

export async function getFeaturedProjects() {
    const { data } = await client.get("/featured-projects");
    return data;
}

export function getFileServeUrl(id) {
    if (!id) return "";
    // If the caller already handed us a fully-qualified URL (external
    // placeholder, legacy field), pass through.
    if (/^https?:\/\//i.test(id) || id.startsWith("/api/")) return id;
    return `${PUBLIC}/files/serve/${id}`;
}
